import React, { useState } from 'react';
import { Rating } from 'react-simple-star-rating';
import { Dialog } from '@/components/Elements/Dialog';
import './css/Review.scss';
import { useNavigate } from 'react-router-dom';
import { useAddReview } from '../api/review';
import Close from '@/assets/img/close-btn.svg';

export const ReviewComponent = () => {
  const [comments, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [isOpen, setIsopen] = useState(true);
  const [isReviewed, setIsreviewed] = useState(false);
  const navigate = useNavigate();

  const addReview = useAddReview();

  const close = () => {
    setIsopen(false);
  };

  const handleRating = (rate: number) => {
    setRating(rate);
  };

  const extractToken = (url: any) => {
    if (url) {
      const match = url.match(/token=([^&]*)/);
      return match ? match[1] : null;
    }
  };

  const tokenData = extractToken(window.location.href);

  const handelAddReviw = async () => {
    const params = new URLSearchParams(location.search);
    const response = await addReview.mutateAsync({
      data: {
        id: undefined,
        comments: comments,
        rating: rating,
        token: tokenData,
      },
      headers: {
        authorization: `Bearer ${params.get('token')}`,
      },
    });
    if (response) {
      setIsreviewed(true);
    }
  };

  return (
    <Dialog isOpen={isOpen} onClose={close}>
      <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all modal-700">
        {
          <div className="flex justify-center">
            <img
              src={Close}
              className="Close-modal"
              onClick={() => {
                setComment('');
                setRating(0);
                setIsopen(false);
                navigate(`/shops`);
              }}
            />
          </div>
        }
        <div className=" flex justify-center">
          {!isReviewed ? (
            <form>
              <div className="review-title">How was your experience? </div>
              <div className="rating-div">
                <Rating onClick={handleRating} initialValue={rating} size={50} />
              </div>
              <div className="input-out-block">
                <textarea
                  id="notes"
                  value={comments}
                  className="review-comment-input "
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Write your review..."
                  rows={3}
                  cols={40}
                />
              </div>
              <div className="btn-component">
                {/* <div className="action text-align-center"> */}
                <button
                  className="petsked-button button-dark fix-width"
                  onClick={(e) => {
                    e.preventDefault();
                    handelAddReviw();
                  }}
                >
                  <span> {addReview.isLoading ? 'Submitting...' : 'Submit'}</span>
                </button>
              </div>
            </form>
          ) : (
            <div>
              <div className="review-title review-padding">Thank you for your review </div>
              <p className="review-success">We truly appreciate your feedback and support.</p>
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};
